import { Button, ButtonProps, CircularProgress } from '@mui/material';
import React, { useCallback, useState } from 'react';

export interface ILoadingButtonProps extends ButtonProps {
	isLoading?: boolean | undefined | null;
}

const LoadingButton: React.FC<ILoadingButtonProps> = ({
	sx,
	onClick,
	disabled,
	startIcon,
	isLoading = undefined,
	...rest
}) => {
	const [loadingInner, setLoadingInner] = useState(false);

	const clickHandler = useCallback(
		async (...args: any[]) => {
			/* istanbul ignore if */
			if (!onClick) {
				return;
			}

			setLoadingInner(true);
			const result = (onClick as (...args: any[]) => any)(...args);
			await Promise.resolve(result);
			setLoadingInner(false);
		},
		[onClick]
	);

	const loading = Boolean(isLoading) === isLoading ? isLoading : loadingInner;

	return (
		<Button
			startIcon={
				loading ? <CircularProgress size={15} sx={{ mr: 2 }} /> : startIcon
			}
			onClick={clickHandler}
			sx={{ pointerEvents: 'all', ...(sx || {}) }}
			disabled={loading || disabled}
			{...rest}
		/>
	);
};

export default LoadingButton;
